export default "﻿<div style=\"height:100%;\">\n    <div data-dojo-attach-point=\"mainContentNode\">\n\n    </div>\n</div>"